'use client';
import { useEffect } from 'react';
import useWindowSize from '@repo/ui/src/components/shared/window-size';
import CheckIcon from '@mui/icons-material/Check';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';

const ProductCarouselItem = ({
  product,
  activeParent,
  setActiveParentInStock,
  setBundleVisible,
}) => {
  const isActive =
    product && activeParent && product?.sku === activeParent?.sku
      ? product?.sku === activeParent?.sku
      : null;
  const [width] = useWindowSize();
  const isMdOrSmaller = width < 992;
  const inStock = product?.isOrderable;
  const currentImgUrl = product?.getMainImageSize(300, 1, 1);

  useEffect(() => {
    if (isActive && inStock) {
      setBundleVisible?.(true);
    }
    if (isActive && !inStock) {
      setBundleVisible?.(false);
    }
    setActiveParentInStock?.(!!inStock);
  }, [activeParent, inStock]);

  if (!product) return null;

  return (
    <>
      <div className="tw-flex tw-justify-items-center">
        <div className={`check-circle ${isActive ? 'is-active' : 'is-not-active'}`}>
          <CheckIcon fontSize="large" className="color-white bundle-check" />
        </div>
      </div>
      <div
        className={`product-bundle-card tw-bg-neutral-100 tw-text-center tw-flex tw-py-2 tw-py-md-4 tw-mx-2 ${
          isActive ? 'is-active' : 'is-not-active'
        }`}
      >
        <div
          className={`tw-flex tw-flex-col tw-align-center tw-px-1 md:tw-px-3 lg:tw-px-4 tw-justify-around ${
            isActive && !isMdOrSmaller ? 'is-active tw-px-4 tw-py-5' : ''
          }`}
        >
          <div className="tw-flex tw-items-center">
            <LazyLoadImage
              imgComponent={
                <img
                  src={currentImgUrl}
                  alt={product.title}
                  className={`tw-mb-0 tw-mx-auto ${
                    isActive ? (inStock ? '' : 'tw-opacity-40') : 'tw-p-2'
                  } tw-p-2`}
                />
              }
            />
          </div>
          {isActive && !inStock ? (
            <div className="tw-flex tw-justify-center">
              <p className="out-of-stock-text mb-0">
                <strong>OUT OF STOCK</strong>
              </p>
            </div>
          ) : null}
          <h4 className="tw-py-3 tw-mb-0">{product.title}</h4>
        </div>
      </div>
      {!(isActive && !inStock) ? (
        <div className="tw-flex tw-justify-items-center tw-pl-3">
          <div className={`little-arrow ${isActive ? 'is-active' : 'is-not-active'}`} />
        </div>
      ) : null}
    </>
  );
};

export default ProductCarouselItem;
